import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommandResult } from '../models/commandResult';
import { Security } from '../utils/security.util';

@Injectable({
  providedIn: 'root'
})
export class SystemService {

  constructor(private http: HttpClient) { }

  getProjectKey() {
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/system/getProjectKey', this.options());
  }

  getAllValue(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/getAllValue', this.simpleOptions());
  }

  getValueRealBs(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/valueRealBs', this.simpleOptions());
  }

  getValueSm(){
    const options = this.simpleOptions();
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/valueSm', options);
  }

  getValueBsReal(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/valueBsReal', this.simpleOptions());
  }

  getValueDolarBs(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/valueDolarBs', this.simpleOptions());
  }

  getValueBsDolar(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/valueBsDolar', this.simpleOptions());
  }

  getValueRealDolar(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/valueRealDolar', this.simpleOptions());
  }

  getValueDolarReal(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/valueDolarReal', this.simpleOptions());
  }

  getFeeEchangeRealBs(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/feeExchangeRealBs', this.options());
  }

  getFeeEchangeRealDolar(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/feeExchangeRealDolar', this.options());
  }

  getFeeEchangeBsReal(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/feeExchangeBsReal', this.options());
  }

  getFeeEchangeBsDolar(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/feeExchangeBsDolar', this.options());
  }

  getFeeEchangeDolarReal(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/feeExchangeDolarReal', this.options());
  }

  getFeeEchangeDolarBs(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/feeExchangeDolarBs', this.options());
  }

  getFeeTransferBetweenUsers(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/feeTransferBetweenUsers', this.options());
  }

  getFeeWithdrawal(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/feeWithdrawal', this.options());
  }

  getMinimumWithdrawalAmount(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/minimumWithdrawalAmount', this.options());
  }

  getFeeDelivery(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/cambio/feeDelivery', this.options());
  }

  checkPayUser(txId: string){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/pix/check/' + txId, this.options());
  }

  options() {
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${Security.getToken()}`)
    .set('api-version', Security.versionApi());
  return { headers };
  }

  simpleOptions(){
    const version = Security.versionApi();
    const headers = new HttpHeaders()
    .set('api-version', version);
  return { headers };
  }
}
